import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["checked"];
import { ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'InputCheckbox',
    props: {
        modelValue: { type: Boolean }
    },
    emits: ['update:modelValue'],
    setup(__props, { expose: __expose }) {
        const props = __props;
        const inputEl = ref();
        __expose({
            focus: () => {
                var _a;
                (_a = inputEl.value) === null || _a === void 0 ? void 0 : _a.focus();
            },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("input", {
                ref_key: "inputEl",
                ref: inputEl,
                type: "checkbox",
                checked: _ctx.modelValue,
                onChange: _cache[0] || (_cache[0] = ($event) => { var _a; return (_ctx.$emit('update:modelValue', (_a = inputEl.value) === null || _a === void 0 ? void 0 : _a.checked)); })
            }, null, 40, _hoisted_1));
        };
    }
});
